import React, { useEffect } from 'react';
import { Col } from 'react-bootstrap5';

import Select from 'components/new_ui/Select';
import { useContext as useTeamsContext } from 'components/Managers/Teams/Context';
import { useContext } from 'components/Managers/Dashboard/Context';

export default function TeamFilter() {
  const { dispatch, actions, state: { filters } } = useContext();
  const {
    dispatch: dispatchTeams,
    actions: actionsTeams,
    state: stateTeams,
  } = useTeamsContext();

  useEffect(() => {
    actionsTeams.load(dispatchTeams);
  }, []);

  const teamsFilterOptions = stateTeams.teams && stateTeams.teams.map(
    (team) => ({ label: team.attributes.title, value: team.id }),
  );

  return (
    <Col>
      <div className="form-label">Team</div>
      <Select
        id="team-id-filter"
        isMulti
        placeholder="All"
        isLoading={stateTeams.teams === null}
        options={teamsFilterOptions || []}
        onChange={(selectedOption) => actions.setTeamFilter(dispatch, filters, selectedOption)}
      />
    </Col>
  );
}
